import { motion } from 'framer-motion';

export default function VisionSection() {
  return (
    <section id="vision" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/6dddca3854548c3390ca0db6eede1f1a.jpg"
          alt="Las Vegas Urban Media"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      <div className="relative z-10 max-w-[1200px] mx-auto px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block text-amber-400 text-xs tracking-[0.4em] uppercase mb-8">
            Strategic Partnership Program
          </span>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-12"></div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[1.1] mb-8"
        >
          <span className="text-amber-400">Own</span> the
          <br />
          Urban <span className="text-amber-400">Skyline</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-white/60 text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light leading-relaxed"
        >
          Strategic investment in premium billboard assets.
          <br />
          Build long-term revenue streams in America's entertainment capital.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a 
            href="#assets"
            className="px-10 py-4 bg-white text-black text-sm font-semibold rounded-lg hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            View Asset Portfolio
          </a>
          <a 
            href="#inquiry"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-10 py-4 border-2 border-amber-400 text-amber-400 text-sm font-semibold rounded-lg hover:bg-amber-400 hover:text-black transition-all cursor-pointer whitespace-nowrap"
          >
            Schedule Consultation
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="absolute bottom-12 left-1/2 -translate-x-1/2"
        >
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
              className="w-1 h-2 bg-amber-400 rounded-full"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
